import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wil-landing-commercial-sections',
  standalone: true,
  templateUrl: './landing-commercial-sections.component.html',
  styleUrl: './landing-commercial-sections.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LandingCommercialSectionsComponent {}
